export default __webpack_public_path__ + "static/media/Rampver Online Logo Square.558faf96.png";